import React, { useState } from 'react';
import { func } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './ContextMenu.module.css';

const ServiceItemContextMenu = ({
    activeItem,
    onDeleteModalOpen,
    onEditServiceCallModalOpen,
    onNewAppointmentModalOpen,
    sendServiceCallNotification,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleSendCommunication() {
        const { id } = activeItem;

        sendServiceCallNotification(id);

        handleClose();
    }

    function handleManageServiceCall() {
        if (activeItem.locked) return;

        onEditServiceCallModalOpen(true);

        handleClose();
    }

    function handleNewAppointment() {
        if (activeItem.locked) return;

        onNewAppointmentModalOpen(true);

        handleClose();
    }

    function handleDeleteServiceCall() {
        if (activeItem.locked) return;

        onDeleteModalOpen(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    process.env.advancedCommEnabled &&
                    <MenuItem onClick={handleSendCommunication}>
                        <img
                            alt="send communication icon"
                            className={classes.contextIcon}
                            src="/assets/images/sendCommunicationIconColor.svg"
                        />
                        Send Communication
                    </MenuItem>
                }
                <MenuItem
                    onClick={handleManageServiceCall}
                    classes={{
                        root: activeItem.locked ? classes.disabled : ''
                    }}
                >
                    <img
                        alt="manage service call icon"
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Edit Summary and Description
                </MenuItem>
                <MenuItem
                    onClick={handleNewAppointment}
                    classes={{
                        root: activeItem.locked ? classes.disabled : ''
                    }}
                >
                    <img
                        alt="new appointment icon"
                        className={classes.contextIcon}
                        src="/assets/images/newAppointmentIconColor.svg"
                    />
                    New Appointment
                </MenuItem>
                <MenuItem
                    onClick={handleDeleteServiceCall}
                    classes={{
                        root: activeItem.locked ? classes.disabled : ''
                    }}
                >
                    <img
                        alt="delete icon"
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

ServiceItemContextMenu.defaultProps = {
    onDeleteModalOpen:         () => {},
    onNewAppointmentModalOpen: () => {}
};

ServiceItemContextMenu.propTypes = {
    onDeleteModalOpen:         func,
    onNewAppointmentModalOpen: func
};

export default ServiceItemContextMenu;
